import { ChevronDown } from "lucide-react";
import { forwardRef, type DetailsHTMLAttributes, type ReactNode } from "react";
import { cn } from "../../lib/cn";

export interface DisclosureProps
  extends Omit<DetailsHTMLAttributes<HTMLDetailsElement>, "children"> {
  children: ReactNode;
  description?: ReactNode;
  label: ReactNode;
  meta?: ReactNode;
}

export const Disclosure = forwardRef<HTMLDetailsElement, DisclosureProps>(function Disclosure({
  children,
  className,
  description,
  label,
  meta,
  ...props
}, ref) {
  return (
    <details ref={ref} data-slot="disclosure" className={cn("ui-disclosure", className)} {...props}>
      <summary data-slot="disclosure-trigger">
        <span data-slot="disclosure-summary" className="ui-disclosure-summary-copy">
          <span data-slot="disclosure-label" className="ui-disclosure-label">{label}</span>
          {description ? <span data-slot="disclosure-description" className="ui-disclosure-description">{description}</span> : null}
        </span>
        <span className="ui-disclosure-summary-end">
          {meta ? <span data-slot="disclosure-meta" className="ui-disclosure-meta">{meta}</span> : null}
          <ChevronDown className="ui-disclosure-chevron" size={18} aria-hidden="true" />
        </span>
      </summary>
      {children}
    </details>
  );
});

Disclosure.displayName = "Disclosure";
